export const INCIDENTS_TABS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived'
} as const;
